export const initialValuesCompany = {
  companyname: "",
  fiscalcode: "",
  vatcode: "",
  countrycodelegal: "",
  zipcodelegal: "",
  citylegal: "",
  countrycodepost: "",
  zipcodepost: "",
  citypost: "",
  email: "",
  phone: "",
  skype: "",
};
